import { useIntl } from 'react-intl';
import { useLanguagePairLinks } from 'src/hooks/useLanguagePairLinks';
import { PageUrlMeta } from 'src/utils/getPageUrlMeta';
import { SidebarSourceLanguageDropdown } from '../SidebarSourceLanguageDropdown';
import { Logo } from '../Logo';
import { SidebarSublist } from '../SidebarSublist';
import { msgs as navMsgs } from '../messages';
import { msgs } from './messages';
import * as S from './styles';

type SidebarProps = {
  alternateLinks?: PageUrlMeta['alternateLinks'];
  isOpen: boolean;
  handleClose: () => void;
};

export const Sidebar = ({ alternateLinks, isOpen, handleClose }: SidebarProps) => {
  const intl = useIntl();
  const { signInHref, blogHref, languagesLinks, coursesLinks, phrasebookLinks } =
    useLanguagePairLinks();

  return (
    <S.Sidebar isOpen={isOpen} handleClose={handleClose}>
      <S.SidebarContent>
        <S.SidebarHeader>
          <S.SidebarMainStripe>
            <Logo />
            <S.CloseButtonWrapper>
              <S.CloseButton onClick={handleClose} aria-label={intl.formatMessage(msgs.close)}>
                <S.CloseIcon />
              </S.CloseButton>
            </S.CloseButtonWrapper>
          </S.SidebarMainStripe>
        </S.SidebarHeader>
        <S.Navigation>
          <S.NavigationList>
            <S.NavigationListItem>
              <S.NavigationLink href={signInHref}>
                {intl.formatMessage(navMsgs.signIn)}
              </S.NavigationLink>
            </S.NavigationListItem>
            {!!languagesLinks.length && (
              <S.NavigationListItem>
                <SidebarSublist
                  buttonText={intl.formatMessage(navMsgs.languages)}
                  links={languagesLinks}
                />
              </S.NavigationListItem>
            )}
            {!!coursesLinks.length && (
              <S.NavigationListItem>
                <SidebarSublist
                  buttonText={intl.formatMessage(navMsgs.courses)}
                  links={coursesLinks}
                />
              </S.NavigationListItem>
            )}
            {!!phrasebookLinks.length && (
              <S.NavigationListItem>
                <SidebarSublist
                  buttonText={intl.formatMessage(navMsgs.phrasebooks)}
                  links={phrasebookLinks}
                />
              </S.NavigationListItem>
            )}
            {blogHref && (
              <S.NavigationListItem>
                <S.NavigationLink href={blogHref}>
                  {intl.formatMessage(navMsgs.blog)}
                </S.NavigationLink>
              </S.NavigationListItem>
            )}

            {!!alternateLinks?.length && (
              <S.NavigationListItem>
                <SidebarSourceLanguageDropdown
                  alternateLinks={alternateLinks}
                  onSelect={handleClose}
                />
              </S.NavigationListItem>
            )}
          </S.NavigationList>
        </S.Navigation>
      </S.SidebarContent>
    </S.Sidebar>
  );
};
